// Example open-source Google reCAPTCHA v2 site key
// This key is provided by Google for testing and development only.
// Docs: https://developers.google.com/recaptcha/docs/faq
export const RECAPTCHA_SITE_KEY = "6Ldx2N0rAAAAAATMI49LKp8UVfYl1TKke8dDIQjn";
